//In service LevelSettings if user wants to add new or remove existing subscribed
//  services from the app they are currently using.

// Hooks
import React, { useEffect, useCallback, useState } from "react";

import PortalOverlay from "../../../../Shared/portal-overlay/portalOverlay";
// Styles
import Styles from "../app-info/appInfo.module.scss";
import Classes from "../../../../Shared/popup.module.scss";
import { ACCENTCOLOR } from "../../../../Shared/colors";

// Constants
import CloseSvg from "../../../../Shared/svg/close";
import EmptyService from "../../../../assets/images/noServicesSubscribe.svg";

// Components

// Functions
import { callApi } from "../../../../api/fetch";
import {
  ensureArray,
  productName,
  productPID,
} from "../../../../utils/dashboardMappers";
import Loading from "../../../../Shared/loading/loading";
import Button from "../../../../Shared/button/button";
import { MEDIUM } from "../../../../Shared/buttonSize";
import {
  primaryButtonHoverStyle,
  primaryButtonStyle,
} from "../../../../Shared/buttonStyles";
import { testIdProps } from "../../../../utils/testIdProps";

function AddServicePopUp({
  onSubmit,
  onCancel,
  enabledService,
  forbiddenServices,
}: any) {
  const [toggleUpdateService, setToggleUpdateService] = useState(false);
  const [orgSubscribedService, setOrgSubscribedService] = useState<any[]>(
    []
  );
  const [appSubscribedServices, setAppSubscribedServices] =
    useState(enabledService);
  const [loading, setLoading] = useState(false);

  const getSubscribedProducts = useCallback(async () => {
    // this array is used to get each id of the product that are already present in the App
    const appIdArray: any = [];
    setLoading(true);
    try {
      const data = ensureArray<any>(
        await callApi("/products?subscription_status=subscribed", {
          method: "GET",
        })
      );

      const subscribedIds = new Set(
        data.map((orgService: any) => productPID(orgService)).filter(Boolean)
      );

      enabledService?.forEach((service: any) => {
        appIdArray.push(productPID(service));
      });

      // filtering the subscribed service with those already present in the App
      let filteredOrgServices = data.filter((orgService: any) => {
        return !appIdArray.includes(productPID(orgService));
      });

      filteredOrgServices = filteredOrgServices.filter((orgService: any) => {
        return !forbiddenServices?.includes(
          productName(orgService).replaceAll(" ", "")?.toLowerCase()
        );
      });

      setOrgSubscribedService(filteredOrgServices);
      setAppSubscribedServices(
        (enabledService || []).filter((service: any) =>
          subscribedIds.has(productPID(service))
        )
      );
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, [enabledService]);

  useEffect(() => {
    getSubscribedProducts();
  }, []);

  function handleCancel(event: any) {
    event.preventDefault();
    onCancel();
    return;
  }
  function handleAddService(event: any) {
    event.preventDefault();
    onSubmit(appSubscribedServices);
    return;
  }
  return (
    <PortalOverlay>
    <div>
      <div
        className={`d-flex align-items-center justify-content-center ${Classes.overlay}`}
        style={{ overflow: "auto" }}
      >
        <div className={`${Classes.popUpContent}`} style={{ width: "50%" }}>
          {loading ? (
            <div
              style={{ height: "400px" }}
              className="d-flex align-items-center justify-content-center"
            >
              <Loading loadingColor={ACCENTCOLOR} />
            </div>
          ) : (
            <div>
              <div className={`p-4 ${Styles.cardHeader} bg-white-color`}>
                <p className={"card_title_bold_text px-2 mb-0"}>
                  Manage Services
                </p>
              </div>
              <div className="p-3">
                <div className="row p-3">
                  <div
                    className={"col-md-6 " + Styles.borderRightManageServics}
                  >
                    <div
                      style={{ textAlign: "center" }}
                      className={`align-items-center ${Styles.headingText}`}
                    >
                      Subscribed Products
                    </div>
                    {orgSubscribedService.length === 0 ? (
                      <div
                        className={`${Styles.emptyStateDiv} d-flex align-items-center justify-content-center`}
                        style={{
                          height: "100%",
                          minHeight: "250px",
                          maxHeight: "450px",
                        }}
                      >
                        <div>
                          <img
                            src={EmptyService}
                            alt="Loading..."
                            width="100px"
                            height="100px"
                          />
                          <p
                            className={`${Styles.emptyStateText} mb-0 pt-2`}
                            style={{ fontSize: "12px" }}
                          >
                            Oops!
                            <br />
                            No more Subscribed Products!
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="py-4"
                        style={{
                          height: "100%",
                          minHeight: "250px",
                          maxHeight: "450px",
                          overflow: "auto",
                        }}
                      >
                        <div className="d-flex flex-wrap">
                          {orgSubscribedService.map((service: any) => {
                            return (
                              <div className="p-1" key={productPID(service)}>
                                <div
                                  className={`${Styles.serviceLevelSettings} p-2`}
                                  style={{
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }}
                                  title={`Enable ${productName(service)} service to the app!`}
                                  {...testIdProps(
                                    `manage-apps-add-service-${productName(service)}`
                                  )}
                                  onClick={() => {
                                    const array: any = [
                                      ...appSubscribedServices,
                                      service,
                                    ];
                                    setOrgSubscribedService(
                                      orgSubscribedService.filter(
                                        (orgService: any) => {
                                          return productPID(service) !== productPID(orgService);
                                        }
                                      )
                                    );
                                    setAppSubscribedServices(() => array);
                                    setToggleUpdateService(true);
                                  }}
                                >
                                  <p
                                    className={`px-1 mb-0 ${Styles.serviceName}`}
                                  >
                                    {productName(service)}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div
                      style={{ textAlign: "center" }}
                      className={`align-items-center ${Styles.headingText}`}
                    >
                      Products added to App
                    </div>
                    {appSubscribedServices.length === 0 ? (
                      <div
                        className={`${Styles.emptyStateDiv} d-flex align-items-center justify-content-center`}
                        style={{
                          height: "100%",
                          minHeight: "250px",
                          maxHeight: "450px",
                        }}
                      >
                        <div>
                          <img
                            src={EmptyService}
                            alt="Loading..."
                            width="100px"
                            height="100px"
                          />
                          <p
                            className={`${Styles.emptyStateText} mb-0 text-center pt-2`}
                            style={{ fontSize: "12px" }}
                          >
                            Click on the tabs to
                            <br />
                            add products to this app
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="py-4"
                        style={{
                          height: "100%",
                          minHeight: "250px",
                          maxHeight: "450px",
                          overflow: "auto",
                        }}
                      >
                        <div className="d-flex flex-wrap">
                          {appSubscribedServices.map((service: any) => {
                            return (
                              <div className="p-1" key={productPID(service)}>
                                <div
                                  style={{
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }}
                                  className={`${Styles.serviceLevelSettings} p-2`}
                                  title={`Disable ${productName(service)} service from the app!`}
                                  {...testIdProps(
                                    `manage-apps-remove-service-${productName(service)}`
                                  )}
                                  onClick={() => {
                                    const array: any = [
                                      ...orgSubscribedService,
                                      service,
                                    ];
                                    setAppSubscribedServices(
                                      appSubscribedServices.filter(
                                        (appService: any) => {
                                          return productPID(service) !== productPID(appService);
                                        }
                                      )
                                    );
                                    setOrgSubscribedService(() => array);
                                    setToggleUpdateService(true);
                                  }}
                                >
                                  <p
                                    className={`mb-0 px-1 ${Styles.serviceName}`}
                                  >
                                    {productName(service)}
                                    <span className="ml-2">
                                      <CloseSvg
                                        width="7"
                                        height="7"
                                        classes={Styles.svgColor}
                                      />
                                    </span>
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-center py-3 w-100 gap-2">
                  <div style={{ width: "200px" }}>
                    <Button
                      size={MEDIUM}
                      id="manage-apps-add-service-cancel"
                      onClick={handleCancel}
                      hoveredStyle={primaryButtonHoverStyle}
                      style={primaryButtonStyle}
                      type="submit"
                      className="bg-lite-accent-color"
                      btnTextClass="primary-color"
                    >
                      Cancel
                    </Button>
                  </div>
                  <div style={{ width: "200px" }}>
                    <Button
                      hoveredStyle={primaryButtonHoverStyle}
                      disabled={!toggleUpdateService}
                      style={primaryButtonStyle}
                      id="manage-apps-add-service-submit"
                      onClick={handleAddService}
                      size={MEDIUM}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    </PortalOverlay>
  );
}

export default AddServicePopUp;
